<template>
  <el-dialog
    width="350px"
    :visible="modalVisible"
    :before-close="handleCloseModal"
    :close-on-click-modal="false"
  >
    <div v-if="id" class="recording-info black-text">
      <h2 class="form-section-header">
        Call Recording
      </h2>
      <div class="info">
        <div>
          <span class="info__title">Unique Id: </span>{{ id }}
        </div>
        <div>
          <span class="info__title">Start time: </span>{{ recordingDateFormatter(startDB) }}
        </div>
      </div>
      <div class="info mt-10">
        <div>
          <span class="info__title">Caller Name: </span>{{ callerName }}
        </div>
        <div>
          <span class="info__title">Caller Number: </span>{{ callerNum | phoneNumber }}
        </div>
      </div>
      <div class="info mt-10">
        <div>
          <span class="info__title">Number Dialed: </span>{{ dialedNum | phoneNumber }}
        </div>
        <div>
          <span class="info__title">Disposition: </span>{{ disposition }}
        </div>
        <div>
          <span class="info__title">Duration: </span>{{ convertTime(duration) }}
        </div>
      </div>
    </div>
    <div class="callrecording-source mt-30">
      <div class="callrecording-actions">
        <el-button
          @click="streamCallRecording"
          v-if="!playActive"
          icon="el-icon-caret-right"
          circle
          size="small"
        >
        </el-button>
        <el-button
          v-loading="fileLoading"
          @click="pauseCallRecording"
          v-if="playActive"
          icon="mdi mdi-pause"
          circle
          size="small"
        >
        </el-button>
        <el-tooltip
          class="item"
          effect="dark"
          content="Save recording"
          placement="top"
        >
          <el-button
            v-loading="downloadLoading"
            @click="saveAudio"
            size="small"
            circle
            icon="el-icon-document"
            style="cursor: pointer;"
          >
          </el-button>
        </el-tooltip>
        <div class="cr-audio-progress">
          <progress :id="'progress-bar-' + id" value="0" max="1"> </progress>
          <div class="black-text time-left-text">
            {{ timeLeft }}
          </div>
        </div>
      </div>
      <div class="callrecording-av" v-show="audioURL.length && isStreaming">
        <div :id="'cr-audio-' + id">
          <audio src=""></audio>
        </div>
      </div>
    </div>
  </el-dialog>
</template>

<script>
import { mapGetters } from "vuex";
import moment from 'moment-timezone';
import feathersClient from "../../../../feathers/feathers-client";
import {phoneNumberFormatter} from "@/globals/globals";
export default {
  name: "CallRecordingAudio",
  props: {
    modalVisible: { required: true },
    id: { required: true },
    start: {required: true},
    duration: {required: true},
    callerNum: {required: true},
    callerName: {required: true},
    disposition: {required: true},
    dialedNum: {required: true},
    startDB: {required: true}
  },
  computed: {
    user() {
      return this.$store.state.auth.user;
    },
    recording() {
      return this.$store.getters["call-recordings/get"](this.id);
    },
    selectedTenant(){
      return this.$store.state.selectedTenant;
    },
    userOffsetMinutes(){
      return this.$store.state.userTimeOffset;
    }
  },
  data() {
    return {
      playActive: false,
      isStreaming: false,
      isPaused: false,
      audioURL: "",
      audioObject: {},
      fileLoading: false,
      fileRetrieved: false,
      timeLeft: null,
      downloadLoading: false
    };
  },
  methods: {
    ...mapGetters("call-recordings", {
      getRecording: "find"
    }),
    saveAudio() {
      this.downloadLoading = true;
      feathersClient.service('call-recordings').get(this.id, {
        query: {
          uniqueId: this.id,
          start: this.startDB,
          tenantId: this.selectedTenant.id
        }
      }).then(res => {
        if(!res.uri){
          this.$notify({
            title: 'Not Found',
            message: 'File Not Found.',
            type: 'warning'
          });
          this.downloadLoading = false;
        } else{
          this.downloadLoading = false;
          const link = document.createElement("a");
          link.href = res.uri;
          link.download = `${this.id}.mp3`;
          link.click();
        }

      }).catch(() => {
        this.downloadLoading = false;
      });
    },
    timeLeftFormatter(time) {
      const remainderSeconds = time % 3600;
      let minutes = Math.floor(remainderSeconds / 60);
      let seconds = Math.round(remainderSeconds % 60);
      if (minutes > 0) {
        if (minutes < 10) {
          minutes = "0" + minutes;
        }
        if (seconds < 10) {
          seconds = "0" + seconds;
        }
        if (seconds === 60) {
          return minutes + ":59";
        }
        return minutes + ":" + seconds;
      }
      if (seconds > 0) {
        if (seconds < 10) {
          seconds = "0" + seconds;
        }
        if (seconds === 60) {
          return "00:59";
        }
        return "00:" + seconds;
      }
      return "00:00";
    },
    streamCallRecording() {
      this.playActive = true;
      if (!this.isStreaming && !this.fileRetrieved) {
        this.fileLoading = true;
        feathersClient.service('call-recordings').get(this.id, {
          query: {
            uniqueId: this.id,
            start: this.startDB,
            tenantId: this.selectedTenant.id
          }
        }).then(data => {
          if (!data.uri) {
            this.$notify({
              title: 'Not Found',
              message: 'File Not Found.',
              type: 'warning'
            });
            this.fileLoading = false;
          } else {
            this.audioObject = document
              .getElementById("cr-audio-" + this.id)
              .querySelector("audio");
            this.audioObject.src = data.uri;
            this.fileLoading = false;
            this.audioObject.play();
            this.isStreaming = true;
            this.fileRetrieved = true;
            this.audioObject.addEventListener("ended", () => {
              this.playActive = false;
              this.isStreaming = false;
              this.isPaused = false;
            });
            this.audioObject.addEventListener("timeupdate", () => {
              this.initProgressBar();
            });
          }
        });
      }
      if (this.isStreaming) {
        this.audioObject.play();
      }
      if (!this.isStreaming && this.fileRetrieved) {
        this.audioObject.play();
        this.playActive = true;
        this.isStreaming = true;
      }
    },
    initProgressBar() {
      const length = this.audioObject.duration ? this.audioObject.duration : 0;
      const current_time = this.audioObject.currentTime;
      if (length) {
        this.timeLeft = this.timeLeftFormatter(length - current_time);
      }
      let progressBar = document.getElementById("progress-bar-" + this.id);
      if (length) {
        progressBar.value = current_time / length;
      } else {
        progressBar.value = length;
      }
      progressBar.addEventListener("click", event => {
        const percent = event.offsetX / progressBar.offsetWidth;
        this.audioObject.currentTime = percent * length;
        progressBar.value = percent / 100;
      });
    },
    pauseCallRecording() {
      this.playActive = false;
      if (this.isStreaming) {
        this.audioObject.pause();
        this.isPaused = true;
      }
    },
    handleCloseModal() {
      if (this.fileRetrieved) {
        const progressBar = document.getElementById("progress-bar-" + this.id);
        progressBar.value = 0;
        this.audioObject.pause();
      }
      this.playActive = false;
      this.isStreaming = false;
      this.isPaused = false;
      this.audioURL = "";
      this.audioObject = {};
      this.fileLoading = false;
      this.fileRetrieved = false;
      this.timeLeft = null;
      this.$emit("closeModal");
    },
    convertTime(time) {
      const hours = Math.floor(time / 3600);
      const remainderSeconds = time % 3600;
      const minutes = Math.floor(remainderSeconds / 60);
      const seconds = Math.round(remainderSeconds % 60);
      if (hours > 0) {
        return hours + "hr " + minutes + "m";
      }
      if (minutes > 0) {
        return minutes + "m " + seconds + "s" ;
      }
      if (seconds > 0) {
        return seconds + "s";
      }
      return "0";
    },
    recordingDateFormatter(value){

      const offsetMinutes = Math.abs(this.userOffsetMinutes);
      return this.userOffsetMinutes < 0
        ? moment(value)
          .subtract(offsetMinutes, "minutes")
          .format("MMM D, YYYY hh:mm A")
        : moment(value)
          .add(offsetMinutes, "minutes")
          .format("MMM D, YYYY h:mm A");
    }
  },
  filters: {
    phoneNumber(value) {
      return value ? phoneNumberFormatter(value) : value;
    }
  }
};
</script>

<style lang="scss" scoped>
@import "../../../../assets/scss/variables";
.recording-info {
  .info {
    &__title {
      font-weight: bold;
    }
  }
}
.cr-audio {
  canvas {
    display: none !important;
  }
}
.callrecording-source {
  width: 200px;
  max-width: 200px;
  cursor: pointer;
}
.callrecording-actions {
  display: flex;
  align-items: center;
}
.cr-audio-progress {
  margin-left: 15px;
  display: flex;
  align-items: center;
}
.time-left-text {
  margin-left: 10px;
  margin-top: -2px;
}
progress[value] {
  /* Reset the default appearance */
  -webkit-appearance: none;
  -moz-appearance: none;
  appearance: none;
  width: 150px;
  height: 10px;
}
progress[value]::-webkit-progress-bar {
  background-color: #eee;
  border-radius: 50px;
  box-shadow: 0 2px 5px rgba(0, 0, 0, 0.25) inset;
}
progress[value]::-moz-progress-bar {
  background-color: #eee;
  border-radius: 50px;
  box-shadow: 0 2px 5px rgba(0, 0, 0, 0.25) inset;
}
progress[value]::-webkit-progress-value {
  background: transparentize($voxo-blue, 0.2);
  border-radius: 50px;
}
.inline-group {
  display: flex;
  align-items: center;
}
.flex-three{
  display: flex;
  >*{
    flex-basis: 33.3333333%;
  }
}
</style>
